<template>
    <div class="button" :style='getStyle' :class="{cursor_pointer: state}"
         @click="navigate">
        <div v-if="state" class="hoverCover">
        </div>
        <div v-else class="disableCover">

        </div>

    </div>
</template>

<script>


    export default {
        name: "actionButton",
        props: ['hoverImg', 'state', 'navigateUrl'],

        data: function () {
            return {
                hovered: 0,
                backgroundImage: ""
            }


        },
        mounted() {
            this.backgroundImage = "background-image: url(" + process.env.BASE_URL + "images/" + this.hoverImg + ")";

        },
        computed: {
            getStyle: function () {
                return this.backgroundImage;
            },
        },
        methods: {
            navigate: function () {
                if (this.state)
                    //this.$router.push(this.navigateUrl);
                    window.location = this.navigateUrl;
            },


        }
    }
</script>

<style scoped>

    .button {
        position: relative;
        display: inline-block;
        width: 200px;
        height: 200px;
        margin: 5px;




    }

    .cursor_pointer {
        cursor: pointer;
    }

    .hoverCover {
        position: absolute;
        top: 2px;
        left: 5px;
        bottom: 80px;
        right: 8px;
        border-radius: 21px;
        background-color: rgba(0, 0, 0, 0.1);
    }

    .disableCover {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(128, 128, 128, 0.7);
    }

    .button:hover .hoverCover {
        background-color: rgba(0, 0, 0, 0);
    }

</style>